// 安全截取函数
export const safeTruncate = (str, maxLength, suffix = '') => {
    // 参数验证
    if (typeof str !== 'string') {
        return '';
    }

    if (maxLength <= 0) {
        return '';
    }

    // 如果字符串长度小于等于最大长度，直接返回
    if (str.length <= maxLength) {
        return str;
    }

    // 截取并添加后缀
    return str.substring(0, maxLength) + suffix;
}